import * as types from "../actions/ActionTypes";
import { FieldsInitial } from "../store/InitialStore";

export default function FieldValidateReducer(state = FieldsInitial, action) {
  const { type, payload, field } = action;
  switch (type) {
    case types.GOTO_NEXT_STEP:
      return {
        ...state,
        currentStep: parseInt(payload) + 1,
      };
    case types.GOTO_PREVIOUS_STEP:
      return {
        ...state,
        currentStep: parseInt(payload) - 1,
      };
    case types.GOTO_SELECTED_STEP:
      return {
        ...state,
        currentStep: parseInt(payload),
      };
    case types.FIELD_VALIDATE_USER:
      return {
        ...state,
        [field]: payload,
      };
    default:
      return state;
  }
}
